export type DataType = 'str' | 'number' | 'currency' | 'int'
  | 'date' | 'time' | 'datetime' | 'percent' | 'bool' | 'ref';
export const DataType = {
  str: 'str' as DataType,
  num: 'number' as DataType,
  currency: 'currency' as DataType,
  int: 'int' as DataType,
  date: 'date' as DataType,
  time: 'time' as DataType,
  datetime: 'datetime' as DataType,
  percent: 'percent' as DataType,
  bool: 'bool' as DataType,
  ref: 'ref' as DataType,
  isNumeric(dt: DataType) {
    return (dt === DataType.num) || (dt === DataType.currency)
      || (dt === DataType.int) || (dt === DataType.percent);
  },
  isDate(dt: DataType) {
    return dt === DataType.date || dt === DataType.datetime ||
      dt === DataType.time;
  }
};

// export type InputType = 'text' | 'password' | 'number' | 'date' | 'time' | 'datetime'
//   | 'checkbox' | 'radio' | 'select' | 'pickup' | 'spinint' | 'spindate' | 'email' | 'url' | 'ip';
// export const InputType = {
//   text: 'text' as InputType,
//   password: 'password' as InputType,
//   num: 'number' as InputType,
//   date: 'date' as InputType,
//   time: 'time' as InputType,
//   datetime: 'datetime' as InputType,
//   checkbox: 'checkbox' as InputType,
//   radio: 'radio' as InputType,

//   select: 'select' as InputType,
//   pickup: 'pickup' as InputType,
//   spinInt: 'spinint' as InputType,
//   spinDate: 'spindate' as InputType,
//   email: 'email' as InputType,
//   url: 'url' as InputType,
//   ip: 'ip' as InputType
// };

export type DataAgg = 'sum' | 'min' | 'max' | 'avg' | 'count';
export const DataAgg = {
  sum: 'sum' as DataAgg,
  min: 'min' as DataAgg,
  max: 'max' as DataAgg,
  avg: 'avg' as DataAgg,
  count: 'count' as DataAgg
};

export type SortDir = 'asc' | 'desc';
export const SortDir = {
  asc: 'asc' as SortDir,
  desc: 'desc' as SortDir
};

export type CompareMethod = '=' | '>' | '<' | '<>' | '>=' | '<=';
export const CompareMethod = {
  eq: '=' as CompareMethod,
  gt: '>' as CompareMethod,
  lt: '<' as CompareMethod,
  ge: '>=' as CompareMethod,
  le: '<=' as CompareMethod,
  ne: '<>' as CompareMethod,
};


// export type Align = 'left' | 'center' | 'right';
// export const Align = {
//   left: 'left' as Align,
//   center: 'center' as Align,
//   right: 'right' as Align
// };


// function merge(...args) {
//   let ret = {};
//   if (!args) return ret;
//   args.forEach(val => {
//     if (!val) return;
//     for (let prop in val)
//       ret[prop] = val[prop];
//   })
// }
